"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardExportComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
// INTERNAL BITS
const bid_data_service_1 = require("./bid-data.service");
const loading_service_1 = require("./loading.service");
const notification_service_1 = require("./notification.service");
const events_1 = require("./events");
let DashboardExportComponent = class DashboardExportComponent {
    constructor(_bidData, _loading, _talk) {
        this._bidData = _bidData;
        this._loading = _loading;
        this._talk = _talk;
        this.showFileSelection = false;
        this.title = 'Select Export File Type';
        this.submitBtnText = 'Start Export';
        this.sortByKey = 'dfp_revenue';
        this.sortOrder = '-';
        this.emailData = false;
        this.rowsLimit = null;
        this.onExportClose = new core_1.EventEmitter();
        this.onExportError = new core_1.EventEmitter();
        this.EXPORT_TYPES = ['csv', 'xlsx', 'html', 'txt'];
        this.exportFileType = 'csv';
        this.csvWriter = false;
        this.csvWriter = this._bidData.csvWriter;
    }
    startExport() {
        this.logExportEvent();
        this.closeExport();
        this._loading.start(`Building ${this.exportFileType} file`);
        this._bidData.getExportedDataJSON({
            exportType: this.exportFileType,
            sortBy: this.sortByKey,
            sortOrder: (this.sortOrder === '-') ? 'desc' : 'asc',
            emailData: this.emailData,
            rowsLimit: this.rowsLimit
        }).then(data => {
            this._loading.stop();
            if (data.message === 'DataExportQueued') {
                this._talk.broadcast(`
         <h2>Export Sucessfully Queued</h2> 
         <p>Once the data processing completes, an email will be delivered to this address: <b>${data.userEmail}</p>
        `);
            }
            else if (data.filename && data.exportName) {
                let link = document.createElement('a');
                link.href = `/export/getfile/${this.exportFileType}/${data.exportName}`;
                link.download = data.filename;
                link.click();
            }
            else {
                this._talk.broadcast(`There is currently no data available to be exported on your Dashboard. What this means is that you either have not yet launched your Biddr360 File onto your site, or your file has been live for less than 24 hours.<br/><br/>If you feel you are seeing this message in error, please contact your Account Manager.`);
            }
        })
            .catch(err => {
            console.log('export error', err);
            this._loading.stop();
            this.closeExport();
            this.onExportError.emit(err);
        });
    }
    closeExport() {
        this.showFileSelection = false;
        this.onExportClose.emit(this.showFileSelection);
    }
    logExportEvent() {
        const context = this.emailData ? 'email-file-type' : 'file-type';
        this.events.send({
            subFeature: events_1.EventSubFeature.export,
            context: context,
            action: events_1.EventAction.export,
            subject: this.exportFileType
        });
    }
};
exports.DashboardExportComponent = DashboardExportComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], DashboardExportComponent.prototype, "showFileSelection", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DashboardExportComponent.prototype, "title", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DashboardExportComponent.prototype, "submitBtnText", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], DashboardExportComponent.prototype, "cumulativeView", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", events_1.DashboardEvents)
], DashboardExportComponent.prototype, "events", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DashboardExportComponent.prototype, "sortByKey", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DashboardExportComponent.prototype, "sortOrder", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DashboardExportComponent.prototype, "dataSource", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], DashboardExportComponent.prototype, "emailData", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], DashboardExportComponent.prototype, "rowsLimit", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], DashboardExportComponent.prototype, "onExportClose", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], DashboardExportComponent.prototype, "onExportError", void 0);
exports.DashboardExportComponent = DashboardExportComponent = __decorate([
    (0, core_1.Component)({
        selector: 'dashboard-export',
        template: `<div class="export-opts-container" [ngClass]="{'absolute-position': !emailData}" *ngIf="showFileSelection">
  <div class="form-group inline-block">
    <label for="sel1">{{title}}:</label>
    <select [(ngModel)]="exportFileType" class="form-control" id="sel1" [disabled]="emailData && csvWriter">
      <option *ngFor="let type of EXPORT_TYPES" [ngValue]="type">{{type|uppercase}}</option>
    </select>
  </div>
  <div class="btn btn-default" (click)="startExport()"><i class="fa fa-download"></i> {{submitBtnText}}</div>
</div>`,
        // Keeping styles inline for now 
        styles: [
            ':host{position:relative}',
            `.absolute-position {
    position:absolute;
    right: 0;
    top: 80px;
    z-index: 120;}`,
            `.export-opts-container {
    margin: 0 auto;
    background-color: white;
    padding: 15px;
    width: 300px;
    border: 1px solid black;
    border-radius: 5px;}`,
            '.export-opts-container .btn{ width:100%;}',
            'label{font-size: 1.5em;}',
            'button{width: 100%;padding: 5px;border: 1px solid black;border-radius: 5px;background-color: lightgrey;}'
        ]
    }),
    __metadata("design:paramtypes", [bid_data_service_1.BidDataService,
        loading_service_1.LoadingService,
        notification_service_1.NotificationService])
], DashboardExportComponent);
//# sourceMappingURL=dashboard-export.component.js.map